var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.0833C22 23.3385 17.9706 24 13 24C8.02944 24 4 23.3385 4 21.0833C4 18.8282 8.02944 15.8333 13 15.8333C17.9706 15.8333 22 18.8282 22 21.0833Z",
    stroke: "url(#paint0_linear_1742_1699)",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.66667C17.5 10.244 15.4853 12.3333 13 12.3333C10.5147 12.3333 8.5 10.244 8.5 7.66667C8.5 5.08934 10.5147 3 13 3C15.4853 3 17.5 5.08934 17.5 7.66667Z",
    stroke: "url(#paint1_linear_1742_1699)",
    strokeWidth: 1.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1742_1699",
    x1: 28.2769,
    y1: 20.1701,
    x2: 19.4585,
    y2: 29.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1742_1699",
    x1: 28.2769,
    y1: 20.1701,
    x2: 19.4585,
    y2: 29.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFill);
export default __webpack_public_path__ + "static/media/user-fill.c08e4c19f5e3d935bfac821ea1871854.svg";
export { ForwardRef as ReactComponent };